/**
 * Pill state variants used for option state management
 */
export const PROPERTY_EDITOR_PILL_STATE_VARIANT = {
    OptedIn: 'OptedIn',
    OptedOut: 'OptedOut',
    InActive: 'InActive',
} as const

export const PILL_TRACK_CHANGE_STATE = {
    Added: 'ADDED',
    Modified: 'MODIFIED',
    ResetOption: 'RESETOPTION',
    Disabled: 'DISABLED',
} as const
